import {
  createStore, applyMiddleware, compose, Store, AnyAction,
} from 'redux';
import thunk from 'redux-thunk';
import { IBeneficiaryState } from './reducers/beneficiaryReducer';
import { IDashboardState } from './reducers/dashboardReducer';
import rootReducer from './reducers/rootReducer';
import { IUserProfileState } from './reducers/userReducer';
import { ILoanApplicationState } from './reducers/loanApplicationReducers';
import { IDisbursementPayoutState } from './reducers/disbursementPayoutReducer';
import { ILoanState } from './reducers/loanReducer';
import { IFlashMessageState } from './actions/flashMessageAction';
import { IRepaymentState } from './types/RepaymentTypes';
import { ISubmissionState } from './types/Submission';
import { IBorrowerProfileState } from './reducers/borrowerProfileReducer';
import { IPaymentPlanState } from './reducers/paymentPlanReducer';

// Create an interface for the application state
export interface IAppState {
  dashboardState: IDashboardState;
  userState: IUserProfileState;
  submissionState: ISubmissionState;
  loanApplicationState: ILoanApplicationState
  flashMessageState: IFlashMessageState;
  repaymentState: IRepaymentState;
  disbursementPayoutState: IDisbursementPayoutState;
  borrowerProfileState: IBorrowerProfileState;
  loanState: ILoanState;
  beneficiaryState: IBeneficiaryState;
  paymentPlanState: IPaymentPlanState;
}

const middleware = [thunk];

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(): Store<IAppState, AnyAction> {
  const store = createStore(
    rootReducer,
    undefined,
    composeEnhancers(applyMiddleware(...middleware)),
  );
  return store;
}
